module.exports = __webpack_public_path__ + "img/J12685.2eecda37.png";